export default function HomeBanner3() {
  const coreFeatures = [
    {
      title: "Scalable Architecture",
      desc: "Built to grow with your business and handle increasing demand.",
    },
    {
      title: "Secure and Reliable",
      desc: "Industry-standard security practices to protect your data and users.",
    },
    {
      title: "Fast Performance",
      desc: "Optimized for speed, responsiveness, and smooth user experience.",
    },
    {
      title: "Analytics and Reporting",
      desc: "Built-in insights to track performance and make data-driven decisions.",
    },
    {
      title: "Cross-Platform Compatibility",
      desc: "Works across devices, including mobile, tablet, and desktop.",
    },
  ];

  const process = [
    {
      title: "Discovery and Planning",
      desc: "Understanding your goals, users, and technical requirements.",
    },
    {
      title: "UI and UX Design",
      desc: "Clean, intuitive interfaces focused on user experience.",
    },
    {
      title: "Development",
      desc: "Agile, iterative development with continuous feedback.",
    },
    {
      title: "Testing and QA",
      desc: "Performance, security, and usability testing.",
    },
    {
      title: "Deployment and Support",
      desc: "Launch, monitoring, and ongoing improvements.",
    },
  ];

  return (
    <section className="ap-section">
      <div className="container">
        <div className="row mb-5">
          <div className="col-lg-8">
            <span className="ap-eyebrow">OUR METHODOLOGY</span>
            <h2 className="ap-title">Engineered For Performance And Efficiency</h2>
            <p className="ap-subtitle">
              From planning to launch, every phase is structured to deliver
              clarity, speed, and long-term value.
            </p>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-lg-6">
            <div className="ap-panel">
              <div className="ap-panel-header">
                <h3 className="ap-panel-title">Core Features</h3>
                <p className="ap-panel-text">Designed to deliver reliability and clarity at every stage.</p>
              </div>

              <div className="ap-feature-list">
                {coreFeatures.map((item, index) => (
                  <div key={index} className="ap-feature-item">
                    <div className="ap-feature-icon">{String(index + 1).padStart(2, "0")}</div>
                    <div>
                      <h5 className="ap-item-name">{item.title}</h5>
                      <p className="ap-item-desc">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="ap-panel ap-panel-dark">
              <div className="ap-panel-header">
                <h3 className="ap-panel-title text-white">Development Process</h3>
                <p className="ap-panel-text text-white-50">A collaborative workflow that keeps you in control.</p>
              </div>

              <div className="ap-process-list">
                {process.map((step, index) => (
                  <div key={index} className="ap-process-item">
                    <div className="ap-step-num">{index + 1}</div>
                    <div className="ap-process-content">
                      <h5 className="ap-item-name text-white">{step.title}</h5>
                      <p className="ap-item-desc text-white-50">{step.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .ap-section {
          padding: 100px 0;
          background: #fcfcfd;
        }

        .ap-eyebrow {
          color: #e88a1c;
          font-weight: 800;
          font-size: 0.75rem;
          letter-spacing: 2px;
          display: block;
          margin-bottom: 10px;
        }

        .ap-title {
          font-size: clamp(2rem, 5vw, 3rem);
          font-weight: 800;
          color: #1a1a2e;
          letter-spacing: -0.03em;
          margin-bottom: 20px;
          line-height: 1.1;
        }

        .ap-subtitle {
          font-size: 1.15rem;
          color: #64748b;
          max-width: 600px;
        }

        .ap-panel {
          background: white;
          padding: 50px;
          border-radius: 4px;
          border: 1px solid rgba(0, 0, 0, 0.05);
          height: 100%;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
        }

        .ap-panel-dark {
          background: #1a1a2e;
          border: none;
        }

        .ap-panel-header {
          margin-bottom: 40px;
        }

        .ap-panel-title {
          font-weight: 800;
          font-size: 1.75rem;
          margin-bottom: 10px;
          color: #1a1a2e;
        }

        .ap-panel-text {
          color: #64748b;
          font-size: 0.95rem;
        }

        .ap-feature-item {
          display: flex;
          gap: 20px;
          margin-bottom: 30px;
        }

        .ap-feature-icon {
          font-weight: 800;
          font-size: 0.8rem;
          color: #e88a1c;
          background: rgba(232, 138, 28, 0.1);
          min-width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 2px;
        }

        .ap-process-item {
          display: flex;
          gap: 25px;
          margin-bottom: 35px;
          position: relative;
        }

        .ap-process-item:not(:last-child)::after {
          content: "";
          position: absolute;
          left: 20px;
          top: 45px;
          width: 1px;
          height: calc(100% - 10px);
          background: rgba(255, 255, 255, 0.1);
        }

        .ap-step-num {
          background: #e88a1c;
          color: white;
          min-width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 800;
          border-radius: 50%;
          font-size: 0.9rem;
          position: relative;
          z-index: 2;
        }

        .ap-item-name {
          font-weight: 700;
          font-size: 1.1rem;
          margin-bottom: 5px;
          color: #1a1a2e;
        }

        .ap-item-desc {
          font-size: 0.9rem;
          line-height: 1.5;
          color: #64748b;
          margin: 0;
        }

        @media (max-width: 768px) {
          .ap-section {
            padding: 60px 0;
          }

          .ap-panel {
            padding: 30px;
          }
        }
      `}</style>
    </section>
  );
}
